import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminConcierge() {
  const [msgs, setMsgs] = useState([]);
  useEffect(() => {
    api.get("/concierge/messages").then((r) => setMsgs(r.data || []));
  }, []);

  return (
    <div className="p-8 md:p-12" data-testid="admin-concierge">
      <header className="mb-8">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier</p>
        <h1 className="font-serif text-5xl mt-2">Concierge Inbox</h1>
      </header>
      <div className="space-y-4">
        {msgs.map((m) => (
          <div key={m.message_id} className="bg-poche-ink border border-white/10 p-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-serif text-xl">{m.name}</div>
                <div className="text-xs text-white/55">{m.email} · via {m.channel}</div>
              </div>
              <div className="text-[10px] tracking-luxury uppercase text-white/45">{new Date(m.created_at).toLocaleString()}</div>
            </div>
            <p className="text-white/80 mt-4 leading-relaxed">{m.message}</p>
          </div>
        ))}
        {msgs.length === 0 && <div className="text-center text-white/45 py-16 text-sm">No messages yet.</div>}
      </div>
    </div>
  );
}
